import React from 'react';

/** SVG Person Icon */
function PersonIcon() {
  return (
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="m17.466 16.914c-.159-.052-1.164-.505-.536-2.414h-.009c1.637-1.686 2.888-4.399 2.888-7.07 0-4.107-2.731-6.26-5.905-6.26-3.176 0-5.892 2.152-5.892 6.26 0 2.682 1.244 5.406 2.891 7.088.642 1.684-.506 2.309-.746 2.396-2.238.724-8.325 4.332-8.229 9.586h24.05c.107-5.02-4.708-8.279-8.513-9.586m19.943463-3.079141a23.455896 23.455898 0 0 1 -23.455894 23.455898 23.455896 23.455898 0 0 1 -23.455896 -23.455898 23.455896 23.455898 0 0 1 23.455896 -23.455898 23.455896 23.455898 0 0 1 23.455894 23.455898"
        fill="#4d4d4d" transform="matrix(.34107 0 0 .34107 7.23 7.278)" />
    </svg>
  )
}

export default PersonIcon;
